import Vue from 'vue'
import store from '../store'

import { 
    LISTA_TIPOS_SERVICIOS,
    LISTA_OPCIONES_REPORTE_DESDE,
    LISTA_OPCIONES_REPORTE_AGRUPAR_POR,
    LISTA_OPCIONES_REPORTE_OPCIONES,
    LISTA_OPCIONES_REPORTE_MOSTRAR
} from '@/constantes/reportes/utils'


Vue.filter('fecha', (e) => {

    const date = new Date(e.seconds * 1000);

    const anio = date.getFullYear();
    const mes = ("0" + (date.getMonth() + 1)).slice(-2);
    const dia = ("0" + date.getDate()).slice(-2);

    return `${dia}/${mes}/${anio}`;
})

Vue.filter('hora', (e) => {

    const date = new Date(e.seconds * 1000);

    const minutos =("0" + (date.getMinutes())).slice(-2)
    const horas = ("0" + date.getHours()).slice(-2);
    const format = date.getHours() > 12 ? 'PM' : 'AM'

    return `${horas}:${minutos} ${format}`;
})

Vue.filter('ticket', e => e === 0 ? 'Pendiente' : e)

Vue.filter('precio', e => {

    return Number(e).toFixed(2).replace(/\B(?=(?:\d{3})+(?!\d))/g, ",")

})

const obtenerObjeto = (objeto, id, campo ) => {

    if(!objeto) return ''

    const data = objeto[id]

    if(data) return data[campo]

    return 'N/A'

}

Vue.filter('paciente', id => obtenerObjeto(store.getters.indicePacientes,id,'nombre'))
Vue.filter('nombrePropietario', id => obtenerObjeto(store.getters.indicePropietarios,id,'nombre') )
Vue.filter('producto', id => obtenerObjeto(store.getters.productosLista,id,'nombre') )
Vue.filter('proveedor', id => obtenerObjeto(store.getters.proveedores,id,'razon_social') )
//Vue.filter('almacen', id => obtenerObjeto(store.getters.almacenes,id,'sucursal') )
Vue.filter('responsable', id => obtenerObjeto(store.getters.indiceUsuarios,id,'nombre') )

Vue.filter('sucursal', sucursal => {

    let id = typeof sucursal ==='object' ? (sucursal ? sucursal.id : null) : sucursal

    if(!id) return "Sin sucursal asignada"

    return obtenerObjeto(store.getters.indiceSucursales,id,'nombre')

})

Vue.filter('almacen', almacen => {

   const id = typeof almacen ==='object' ? almacen.id : almacen

    if(id==null) return "Sin sucursal asignada"
    return obtenerObjeto(store.getters.almacenes,id,'nombre')

})

Vue.filter('categoria', categoria => {

    const categoriaStore = store.getters.categorias[categoria.id]
    return (categoriaStore) ? categoriaStore.nombre : categoria.nombre

})

Vue.filter('concepto', concepto => {

    const categoriaStore = store.getters.categorias[concepto.id_categoria]
    if(!categoriaStore) return concepto.nombre
    
    const conceptos = categoriaStore.conceptos || {}
    const conceptoStore = conceptos[concepto.id]
    return conceptoStore ? conceptoStore.nombre : concepto.nombre

})


Vue.filter('unidadMedida', id => {

    const unidades = store.getters.catalogoUnidades

    const unidad = unidades.find(e => e.id )

    return unidad ? unidad.descripcion : ""

})


Vue.filter('tipoServicio', tipo => {

    const servicio = LISTA_TIPOS_SERVICIOS.find(item => item.value === tipo);
    return servicio ? servicio.text : "";

})

Vue.filter('reporteDesde', valor => {
    const result = LISTA_OPCIONES_REPORTE_DESDE[valor];
    return result ? result : "";
})


Vue.filter('reporteAgruparPor', valor => {
    const result = LISTA_OPCIONES_REPORTE_AGRUPAR_POR[valor];
    return result ? result : "";
})

Vue.filter('reporteDescuento', valor => {
    const result = LISTA_OPCIONES_REPORTE_OPCIONES[valor];
    return result ? result : "";
})

Vue.filter('reporteMostrar', valor => {
    const result = LISTA_OPCIONES_REPORTE_MOSTRAR[valor];
    return result ? result : "";
})


// WEBPACK FOOTER //
// ./src/filters/index.js